import continents from './continents/en'
import countries from './countries/en'

export default {
  global: {
    dashboard: 'Dashboard',
    coins: 'Coins',
    coin: 'Coin',
    banknotes: 'Banknotes',
    banknote: 'Banknote',
    books: 'Books',
    book: 'Book',
    logout: 'Logout',
    continent: 'Continent',
    country: 'Country',
    quantity: 'Quantity',
    year: 'Year',
    image: 'Image',
    images: 'Images',
    save: 'Save',
    update: 'Update',
    close: 'Close',
    required: 'Required fields',
    search: 'Search',
    back: 'Back',
    edit: 'Edit',
    delete: 'Delete',
    cancel: 'Cancel',
    add: 'Add',
    yes: 'Yes',
    no: 'No',
    description: 'Description'
  },
  login: {
    title: 'Welcome to Numisma!',
    subtitle: 'Use these awesome forms to login or create new account in your project for free.',
    credentials: {
      title: 'Sign in with credentials',
      signin: 'Sign in'
    },
    forgotten_password: 'Forgotten password?',
    new_account: 'New account',
    email: 'Email',
    password: 'Password'
  },
  register: {
    title: 'Welcome to Numisma!',
    subtitle: 'Use these awesome forms to login or create new account in your project for free.',
    credentials: {
      title: 'Sign in with credentials',
      signin: 'Sign in'
    },
    displayName: 'Username',
    email: 'Email',
    password: 'Password',
    choose_image: 'Choose a picture',
    create_account: 'Create account',
    back: 'Back',
    text: 'Please fill in all fields of the form'
  },
  dashboard: {
    welcome: 'Welcome!',
    title: 'Dashboard',
    map: 'World map'
  },
  coins: {
    list: 'Coins list',
    add: 'Add coin in {country}',
    select_continent: 'Select a continent',
    select_country: 'Select a country',
    none: 'None',
    delete: 'Are you sure you want to delete this coin ?',
    edit: 'Edition',
    info: 'Information',
    new: 'New coin'
  },
  banknotes: {
    list: 'Banknotes list',
    add: 'Add banknote in {country}',
    select_continent: 'Select a continent',
    select_country: 'Select a country',
    none: 'None',
    delete: 'Are you sure you want to delete this banknote ?',
    edit: 'Edition',
    info: 'Information',
    new: 'New banknote'
  },
  books: {
    list: 'Books list',
    none: 'None',
    delete: 'Are you sure you want to delete this book ?',
    delete2: 'Attention, all the contents of the book (coins and banknotes) will be deleted',
    edit: 'Edition',
    info: 'Information',
    new: 'New banknote',
    coins: 'no coin | 1 coin | {count} coins',
    banknotes: 'no banknote | 1 banknote | {count} banknotes'
  },
  user: {
    profile: 'My profile',
    info: 'Information',
    displayName: 'Username',
    email: 'Email',
    password: 'Password',
    photo: 'Photo profile',
    firstname: 'First name',
    lastname: 'Last name'
  },
  continents,
  countries
}



// WEBPACK FOOTER //
// ./src/lang/en.js